import { HttpErrorResponse, HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { LoginService } from "../../service/login/login.service";
import { loginConfig } from "../../config/config";
import { User } from "../../models/users/user";

/**
 * 用户登录组件
 *
 * @export
 * @class LoginComponent
 * @implements {OnInit}
 */

@Component({
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"]
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup; // 响应式登录表单(reactiveform)
  public backgroundImage: string; // 背景图片
  public formTitle: string; // 表单标题
  public user: User;
  public message: string; // 登录提示消息
  public loginLoading: boolean;

  public warning;

  /**构造函数，注入依赖
   * Creates an instance of LonginComponent.
   * @param {FormBuilder} fb
   * @param {Router} router
   * @param {LoginService} LoginService
   * @memberof LonginComponent
   */
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private loginService: LoginService,
    private http:HttpClient
  ) {
    this.user = new User();
    this.backgroundImage = loginConfig.backgroundImage;
    this.formTitle = loginConfig.loginFormTitle;
    this.loginLoading = false;
  }

  // 提交表单登录
  loginUser(_user: User) {
    for (const i in this.loginForm.controls) {
      this.loginForm.controls[i].markAsDirty(); // 标记为脏值
    }

    // 表单有效时，登录验证
    if (this.loginForm.valid) {
      this.loginService.login(_user).subscribe(res => {
        console.log(res)

 

        if (res["message"] == "SUCCESS") {
          sessionStorage.setItem("rolename",res["user"]["role"]["name"]);
          this.loginService.setUser(_user); // 发射当前登录用户
          // this.router.navigateByUrl("home");
          history.go(-1);
          console.log("log in success!");
          
          

         this.http.post(`http://210.77.77.237:8080/dm/oauth/token?client_id=mobile-client&client_secret=mobile&grant_type=password&username=`+_user.UserName+`&password=`+_user.PWD,{}).subscribe(data=>{
            sessionStorage.setItem("access_token",data["access_token"]);
            console.log("登录成功");
         }
        
        )

        }else if(res["message"]=="WRONG"){
          console.log(res);
          this.message = res["message"];
          this.warning="用户名或密码错误"
          //alert("用户名或密码错误");
          
        }else{
          alert("抱歉，该用户不可登录系统，请联系管理员");
        }
      });
    }
  }


  ngOnInit() {
    this.loginForm = this.fb.group({
      UserName: [null, [Validators.required]],
      PWD: [null, [Validators.required]],
      remember: [true],
      required:[true]
    });


    
  }

  requiredChange(event){

  }
}
